import React from "react";
import { Outlet } from "react-router-dom";
import SeoTags from "../util/SeoTags";

function Academy() {
  return (
    <>
      <SeoTags title={"KrisKisStyle | Academia"} />
      <div className="">
        <div className="container">
          <Outlet />
        </div>{" "}
      </div>
    </>
  );
}

export default Academy;
